const jqueryExtend = require('./jqueryExtend/index');
const common = require('./source/common');
const index = require('./source/index');
const news = require('./source/news');
const information = require('./source/information');
const product = require('./source/product');
const sysLoginIcon = require('./source/sysLoginIcon');
const apiCache = require('./source/apiCache');
$(function () {
  jqueryExtend.init();
  common.init();
  index.init();
  news.init();
  information.init();
  product.init();
  sysLoginIcon.init();
  apiCache.init();
});